export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'AI-CONNECTOR': {
    TITLE: 'Connect wokap with your AI',
    SUBTITLE: 'Connect your AI assistant (ChatGPT or Claude) to the wokap connector so it can check out and manage your offers and candidates for you. No tokens to copy, nothing to install — just sign in with your own wokap account.',
    INTRO: {
      WHAT_IS_TITLE: 'So what is this, exactly?',
      WHAT_IS_BODY: 'It\'s a "connector" (fancy name: MCP server) that lets your AI assistant read and manage wokap offers and candidates. When you connect it, your assistant will ask you to sign in with your own wokap account — no tokens to copy, no shared passwords. From there, it sees and does exactly what you could see and do logging into wokap yourself, and every action shows up as done by you.',
      WARNING: 'Heads up: some actions notify the candidate or change real data — think discarding a candidate, sending an interview, or publishing an offer. Your assistant should check with you before doing anything like that, so always take a second look at what it\'s proposing before you say yes.',
    },
    WIZARD: {
      STEP_OF: 'STEP {{current}} OF {{total}}',
      STEP_LABELS: {
        CHOOSE: 'Pick your AI',
        REVIEW: 'Review access',
        CONNECT: 'Connect',
      },
      CANCEL: 'Cancel',
      BACK: 'Back',
      NEED_HELP: 'Need help?',
      STEP_1: {
        TITLE: 'Connect wokap with your AI',
        SUBTITLE: 'Select the AI assistant you use.',
        SECURE_NOTE: 'Secure connection. You sign in with your own wokap account, and you can disconnect it whenever you want.',
        NEXT: 'Next',
      },
      STEP_2: {
        TITLE: 'Review access',
        SUBTITLE: '{{ai}} will be able to help you with the information you already have permission to see.',
        PERMISSIONS: {
          OFFERS: {
            TITLE: 'Offers and processes',
            BODY: 'Check active offers and the status of each process.',
            SCOPE: 'Read',
          },
          CANDIDATES: {
            TITLE: 'Candidates and interviews',
            BODY: 'Check candidate profiles, answers, and interviews.',
            SCOPE: 'Read',
          },
          ACTIONS: {
            TITLE: 'Authorized actions',
            BODY: 'Only the actions your user can already perform, with your confirmation for anything that notifies a candidate or publishes an offer.',
            SCOPE: 'Needs approval',
          },
        },
        ACCOUNT_LABEL: 'Account being connected',
        VERIFIED: 'Verified',
        AUTHORIZE: 'Authorize and continue',
      },
      STEP_3: {
        TITLE: 'Connect wokap with {{ai}}',
        SUBTITLE: 'Follow these steps. It\'ll take less than two minutes.',
        URL_LABEL: 'Connection address',
        DONE: 'I connected it',
        CLAUDE: {
          STEP_1: { TITLE: 'Open Connectors', BODY: 'In Claude, go to Settings and select Connectors.' },
          STEP_2: { TITLE: 'Add a connector', BODY: 'Click "Add custom connector".' },
          STEP_3: { TITLE: 'Paste the address', BODY: 'Type "wokap" as the name, paste the connection address below, and click Add. Claude will ask you to sign in with your wokap account.' },
        },
        CHATGPT: {
          STEP_1: { TITLE: 'Open Connectors', BODY: 'In ChatGPT, go to Settings → Connectors → Advanced settings and turn on developer mode.' },
          STEP_2: { TITLE: 'Add a connector', BODY: 'Click "Create" and choose custom MCP connector.' },
          STEP_3: { TITLE: 'Paste the address', BODY: 'Type "wokap" as the name, paste the connection address below, and click Create. ChatGPT will ask you to sign in with your wokap account.' },
        },
      },
      SUCCESS: {
        TITLE: 'Connection complete',
        HEADLINE: 'wokap is connected!',
        SUBTITLE: '{{ai}} can now help you with your hiring processes.',
        SERVICE_LABEL: 'Connected service',
        ACTIVE: 'Active',
        TRY_IT: 'Try it with one of these prompts:',
        PROMPT_1: 'Show me the active offers for my company in wokap.',
        PROMPT_2: 'Summarize the candidates applied to the [offer name] offer.',
        MANAGE: 'Manage connection',
        OPEN_AI: 'Open my AI',
      },
    },
    COPY: 'Copy',
    COPIED: 'Copied to clipboard',
    FAQ: {
      TITLE: 'Common hiccups',
      Q1: 'I don\'t see a "Connectors" option in my assistant',
      A1: 'Not every AI assistant supports remote MCP connectors yet. Make sure you\'re on the latest version, or search your assistant\'s docs for "MCP" or "Connectors".',
      Q2: 'My assistant doesn\'t ask me to sign in when I paste the address',
      A2: 'Some assistants only ask you to sign in the first time you use a wokap tool, not when you add the connector. Try asking it something like "what offers are open in wokap?".',
      Q3: 'wokap\'s tools aren\'t showing up in the assistant',
      A3: 'Check that the connector got saved and that you finished signing in when it asked. If it still doesn\'t show up, remove the connector and add it again.',
      Q4: 'How do I disconnect wokap from my assistant?',
      A4: 'Go to your assistant\'s Connectors section, find "wokap", and remove it. Access is revoked right away.',
      Q5: 'Still stuck?',
      A5: 'Copy the exact error message and send it over to your technical team.',
    },
    HELP: {
      TITLE: 'Need a hand?',
      BODY: 'Reach out to your technical team or wokap support.',
    },
  },
} as const;
